var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tw-flex tw-h-4 tw-w-4 tw-items-center tw-justify-center tw-rounded-full",class:_vm.outerDot,attrs:{"aria-hidden":"true"}},[_c('span',{staticClass:"tw-h-2 tw-w-2 tw-rounded-full",class:_vm.innerDot})])}
var staticRenderFns = []

export { render, staticRenderFns }